/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDto } from './companyDto';
import { PlaceInformationDto } from './placeInformationDto';
import { ClientLoyaltyProgramDto } from './clientLoyaltyProgramDto';


export interface ClientLocationDto { 
    id?: number;
    displayName?: string;
    receiptName?: string;
    city?: string;
    county?: string;
    country?: string;
    address1?: string;
    address2?: string;
    postalCode?: string;
    lat?: number;
    lng?: number;
    company?: CompanyDto;
    placeInformation?: PlaceInformationDto;
    created?: string;
    office?: boolean;
    active?: boolean;
    hq?: boolean;
    loyaltyProgram?: ClientLoyaltyProgramDto;
    distance?: number;
}

